<template>
  <div v-loading="loading" class="salesOrderPreview">
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr>
            <td class="tableLabel">订单类型</td>
            <td class="tdContent" colspan="5">{{salesOrder.salesOrderCategoryName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">订单编号</td>
            <td class="tdContent">{{salesOrder.salesOrderNo}}</td>
            <td class="tableLabel">制单人</td>
            <td class="tdContent">{{salesOrder.creatorName}}</td>
            <td class="tableLabel">制单时间</td>
            <td class="tdContent">{{salesOrder.createDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">状态</td>
            <td class="tdContent">{{salesOrder.statusName}}</td>
            <td class="tableLabel">提交时间</td>
            <td class="tdContent">{{salesOrder.submitDate}}</td>
            <td class="tableLabel">ERP订单编号</td>
            <td class="tdContent">{{salesOrder.erpSalesOrderNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户合同号</td>
            <td class="tdContent">{{salesOrder.customerContractNo}}</td>
            <td class="tableLabel">项目名称</td>
            <td class="tdContent">{{salesOrder.projectName}}</td>
            <td class="tableLabel">交货日期</td>
            <td class="tdContent">{{salesOrder.deliveryDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户</td>
            <td class="tdContent">{{salesOrder.customerName}}</td>
            <td class="tableLabel">联系人</td>
            <td class="tdContent">{{salesOrder.contact}}</td>
            <td class="tableLabel">联系方式</td>
            <td class="tdContent">{{salesOrder.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">收货地址</td>
            <td class="tdContent" colspan="3">{{deliveryPlace}}</td>
            <td class="tableLabel">商务申请</td>
            <td class="tdContent">{{salesOrder.businessApplicationNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注</td>
            <td class="tdContent" colspan="5">{{salesOrder.note}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div
          style="
            border-bottom: 1px solid #ddd;
            margin-bottom: 10px;
            padding-bottom: 5px;
            font-size: 16px;
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;">
        <div>订单商品</div>
        <div v-if="totalAmount !== 0">总金额：￥{{totalAmount.toFixed(2)}}</div>
        <div v-else>总金额：￥0</div>
      </div>
      <el-table ref="payData" border :data="salesOrder.materialVOS">
        <el-table-column align="center" type="index" label="#" width="55"/>
        <el-table-column align="center" prop="materialNo" label="物料编号" width="150"/>
        <el-table-column 
            align="left"  
            prop="materialName"  
            label="物料名称" 
            min-width="320" 
            show-overflow-tooltip/>
        <el-table-column 
            prop="materialSpecification" 
            align="left" 
            min-width="200" 
            show-overflow-tooltip 
            label="规格型号"/>
        <el-table-column prop="materialTypeName" width="120" align="center" label="物料类型"/>
        <el-table-column align="center" prop="quantity" label="数量" width="60"/>
        <el-table-column align="center" prop="unitName" label="单位" width="50"/>
        <!-- <el-table-column align="center" prop="standardPrice" label="面价" width="80"/> -->
        <el-table-column align="center" prop="price" label="单价(含税)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{scope.row.price}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总价(含税)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{(scope.row.quantity * scope.row.price).toFixed(2)}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="deliveryDate" label="交货日期" width="120"/>
        <el-table-column 
            align="center" 
            prop="note" 
            label="备注" 
            width="240" 
            show-overflow-tooltip/>
      </el-table>
    </div>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">订单附件</div>
      <el-table ref="payData1" border :data="salesOrder.attachments">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>>
      </el-table>
      <div>
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          销售订单BOM
        </div>
        <el-table ref="payData2" border :data="salesOrder.salesOrderBoms">
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="parentMaterialNo" align="left" label="父级物料编号" width="150"/>
          <el-table-column 
              prop="parentMaterialName" 
              align="left" 
              label="父级物料名称" 
              min-width="150" 
              show-overflow-tooltip/>
          <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
          <el-table-column prop="materialName" align="left" label="物料名称" show-overflow-tooltip/>
          <el-table-column prop="quantity" align="right" label="数量" width="60"/>
          <el-table-column prop="levelIndex" align="center" label="层级" width="60"/>
          <el-table-column prop="unit" align="center" label="计量单位" width="70"/>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "SalesOrderPreview",
    data() {
      return {
        loading: false,
        totalAmount: 0,
        deliveryPlace: "", // 收货地址
        salesOrder: {},
      };
    },

    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.getData(val.query.billId);
          }
        },
      },
    },
    // created() {
    //   this.getData(this.$route.query.billId);
    // },

    methods: {
      // 根据销售订单id查询详细信息
      getData(id) {
        this.loading = true;
        this.$http.get("basic", `sd/so/${id}`).then((resp) => {
          if (resp.success) {
            this.salesOrder = resp.data;
            for (let item of this.salesOrder.materialVOS) {
              this.totalAmount += item.quantity * item.price;
            }
            if (this.salesOrder.areaId) {
              this.getDeliveryPlace(this.salesOrder.areaId);
            }
          }
          this.loading = false;
        });
      },

      //获取省市区id获取三级联动
      getDeliveryPlace(id) {
        if (id > 0) {
          this.$http.get("basic", `districts/cascadename/${id}`).then((resp) => {
            if (resp.success) {
              this.deliveryPlace = resp.data + "," + this.salesOrder.deliveryPlace;
            }
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
.salesOrderPreview {
  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #dddddd;
    border-bottom: none;
  }

  table.gridtable td {
    border: 1px solid #ddd;
    padding: 10px 5px;
    border-top: none;
    border-right: none;
    word-break: break-all;
  }

  .tableLabel {
    width: 80px;
    text-align: right;
    background-color: #d1e6f5;
  }
  .tdContent {
    min-width: 200px;
  }
}
</style>
